exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canvasBox[data-v-03cde0c0]{width:100%;position:absolute;top:0;left:0;z-index:0;overflow:hidden}#canvas[data-v-03cde0c0]{height:100%}", ""]);

// exports
